"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pages = void 0;
var _PackageSelection = require("../../components/PackageSelection");
var _CustomerSelection = require("./CustomerSelection");
const Pages = exports.Pages = [_PackageSelection.PackageSelection, _CustomerSelection.CustomerSelection];
